export default __webpack_public_path__ + "static/media/pointOfService.3c2ad7f9.svg";